import React from "react"
import {
  useEnterpriseGetOne,
  useMainEnterpriseId,
} from "../../hooks/enterprise"
import { useShopGetOne, useShopId } from "../../hooks/shop"
import { useAtom as GetAtom } from "jotai"
import {
  checkoutDiscountAtom,
  checkoutSumsAtom,
  checkoutSumTotalAtom,
} from "../../store/checkout"
import { Card } from "@malond/ui/components/card"
import { formatPriceKZT } from "@malond/utils"

export default function CheckoutSummary() {
  const enterpriseId = useMainEnterpriseId()
  const shopId = useShopId()

  // Atoms
  const [checkoutSumTotal] = GetAtom(checkoutSumTotalAtom)
  const [checkoutDiscount] = GetAtom<string>(checkoutDiscountAtom)
  const [checkoutSums] = GetAtom(checkoutSumsAtom)

  // Fetch
  const { isLoading: isLoadingEnterprise, isError: isErrorEnterprise } =
    useEnterpriseGetOne(enterpriseId)
  const { isLoading: isLoadingShop, isError: isErrorShop } = useShopGetOne(
    enterpriseId,
    shopId
  )

  if (
    isLoadingEnterprise ||
    isErrorEnterprise ||
    isLoadingShop ||
    isErrorShop
  ) {
    return null
  }

  const discountNum = Number(checkoutDiscount) || 0

  return (
    <div className="px-4 py-4 sm:px-6">
      <Card className="border-border bg-card p-4 shadow-xs">
        <table className="w-full table-auto">
          <tbody>
            <tr>
              <td>
                <p className="text-base text-muted-foreground">Сумма</p>
              </td>
              <td className="text-right">
                <p className="text-base font-medium text-foreground">
                  {formatPriceKZT(checkoutSums.priceDiscount)}
                </p>
              </td>
            </tr>

            {discountNum > 0 && (
              <tr>
                <td>
                  <p className="text-base text-muted-foreground">
                    Скидка на чек
                  </p>
                </td>
                <td className="text-right">
                  <p className="text-base font-medium text-destructive">
                    - {formatPriceKZT(checkoutDiscount)}
                  </p>
                </td>
              </tr>
            )}

            <tr>
              <td colSpan={2}>
                <div className="my-4 w-full border-t border-border" />
              </td>
            </tr>

            <tr>
              <td>
                <p className="truncate text-lg font-bold text-foreground">
                  Итого
                </p>
              </td>
              <td className="text-right">
                <p className="text-xl font-bold text-primary">
                  {formatPriceKZT(checkoutSumTotal)}
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </Card>
    </div>
  )
}
